import { render, staticRenderFns } from "./borderSta.vue?vue&type=template&id=6c75d258&scoped=true"
import script from "./borderSta.vue?vue&type=script&lang=js"
export * from "./borderSta.vue?vue&type=script&lang=js"
import style0 from "./borderSta.vue?vue&type=style&index=0&id=6c75d258&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c75d258",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\gitee\\fcops_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c75d258')) {
      api.createRecord('6c75d258', component.options)
    } else {
      api.reload('6c75d258', component.options)
    }
    module.hot.accept("./borderSta.vue?vue&type=template&id=6c75d258&scoped=true", function () {
      api.rerender('6c75d258', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workOrder/borderSta.vue"
export default component.exports